import Alpine from "alpinejs";

window.Alpine = Alpine;

document.addEventListener('alpine:init', () => {

    Alpine.data('app', () => ({
        scrolled: false,
        mobileOpen: false,
        activeSection: 'hero',

        init() {
            this.onScroll();
            this.setupSectionObserver();
        },

        onScroll() {
            this.scrolled = window.scrollY > 60;
        },

        setupSectionObserver() {
            const ids = ['hero', 'overview', 'about-project', 'amenities', 'gallery', 'location', 'about', 'contact'];
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) this.activeSection = entry.target.id;
                });
            }, { threshold: 0.25, rootMargin: '-10% 0px -55% 0px' });

            ids.forEach(id => {
                const el = document.getElementById(id);
                if (el) observer.observe(el);
            });
        },

        scrollTo(id) {
            const el = document.getElementById(id);
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            this.mobileOpen = false;
        },

        isActive(sections) {
            return sections.includes(this.activeSection);
        }
    }));

    Alpine.data('amenitiesTabs', () => ({
        activeTab: 'project',
        setTab(tab) { this.activeTab = tab; }
    }));

    Alpine.data('gallery', () => ({
        lightboxOpen: false,
        currentIndex: 0,
        images: [
            { src: './public/images/building-01.jpg', alt: 'Urban Nest Building' },
            { src: './public/images/building-02.jpg', alt: 'Urban Nest Building' },
            { src: './public/images/building-03.jpg', alt: 'Urban Nest Building' },
            { src: './public/images/building-04.jpg', alt: 'Urban Nest Building' },
            { src: './public/images/building-05.jpg', alt: 'Urban Nest Building' },
            { src: './public/images/building-06.jpg', alt: 'Urban Nest Building' },
            { src: './public/images/garden-01.jpg',   alt: 'Urban Nest Gardens'  },
            { src: './public/images/garden-02.jpg',   alt: 'Urban Nest Gardens'  },
            { src: './public/images/garden-03.jpg',   alt: 'Urban Nest Gardens'  },
            { src: './public/images/building-07.jpg', alt: 'Urban Nest Building' },
            { src: './public/images/building-08.jpg', alt: 'Urban Nest Building' },
        ],
        open(index) {
            this.currentIndex = index;
            this.lightboxOpen = true;
            document.body.style.overflow = 'hidden';
        },
        close() {
            this.lightboxOpen = false;
            document.body.style.overflow = '';
        },
        prev() {
            this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
        },
        next() {
            this.currentIndex = (this.currentIndex + 1) % this.images.length;
        }
    }));

    Alpine.data('contactForm', () => ({
        name: '',
        email: '',
        phone: '',
        message: '',
        sending: false,
        status: null,

        async submit() {
            if (!this.name.trim() || !this.email.trim() || !this.phone.trim()) return;
            this.sending = true;
            this.status = null;

            try {
                const res = await fetch('./mail.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        name:    this.name,
                        email:   this.email,
                        phone:   this.phone,
                        message: this.message
                    })
                });
                const data = await res.json();
                this.status = data.success ? 'success' : 'error';
                if (data.success) {
                    this.name = '';
                    this.email = '';
                    this.phone = '';
                    this.message = '';
                }
            } catch {
                this.status = 'error';
            } finally {
                this.sending = false;
                setTimeout(() => { this.status = null; }, 6000);
            }
        }
    }));
});

Alpine.start();
